import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, Metamodel, IModel, ImportExportSettings, SnowflakeSink } from 'shell-models-lib';

import { TabularSinkAdapter } from 'app/model/adapters/activities/copysink/tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { CopySinkAdapter } from './copysink.adapter';
import { ValueAdapter } from '../../value.adapter';
import { toParameterObject, toParameterClass } from '../../linkedservices/parameter-config.util';

export const snowflakeSinkAdapter = {
    type: '*',
    preCopyScript: '*',
    importSettings: '*'
};
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeSink),
    asynchronous: true,
    adapts: snowflakeSinkAdapter,
    disabled: __IS_FABRIC_DPE__
})
export class SnowflakeSinkAdapter extends CopySinkAdapter<SnowflakeSink, Model.SnowflakeSink> {
    protected model(): IModel {
        return SnowflakeSink.MODEL;
    }

    protected override async _toResource(model: SnowflakeSink): Promise<Model.SnowflakeSink> {
        const result: Model.SnowflakeSink = {
            type: this.model().name
        };
        TabularSinkAdapter.toSinkResource(model, result);
        if (model.importSettings != null) {
            result.importSettings = {
                type: 'SnowflakeImportCopyCommand'
            };
            result.importSettings.additionalCopyOptions = Array.isArray(model.importSettings.additionalCopyOptions)
                ? toParameterObject(model.importSettings.additionalCopyOptions)
                : ValueAdapter.toResource(model.importSettings, ImportExportSettings.ADDITIONAL_COPYOPTIONS);
            result.importSettings.additionalFormatOptions = Array.isArray(model.importSettings.additionalFormatOptions)
                ? toParameterObject(model.importSettings.additionalFormatOptions)
                : ValueAdapter.toResource(model.importSettings, ImportExportSettings.ADDITIONAL_FORMATOPTIONS);
        }
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.SnowflakeSink, owner: Activity): Promise<SnowflakeSink> {
        const result = Owned.create<SnowflakeSink>(this.model(), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        if (resource.importSettings != null) {
            result.importSettings = Owned.create<ImportExportSettings>(
                ImportExportSettings.MODEL,
                result
            );
            if (
                resource.importSettings.additionalCopyOptions &&
                typeof resource.importSettings.additionalCopyOptions === 'object' &&
                resource.importSettings.additionalCopyOptions.type !== 'Expression'
            ) {
                result.importSettings.additionalCopyOptions = toParameterClass(
                    resource.importSettings.additionalCopyOptions,
                    result.importSettings
                );
            } else {
                ValueAdapter.toModel(
                    result.importSettings,
                    ImportExportSettings.ADDITIONAL_COPYOPTIONS,
                    resource.importSettings.additionalCopyOptions
                );
            }
            if (
                resource.importSettings.additionalFormatOptions &&
                typeof resource.importSettings.additionalFormatOptions === 'object' &&
                resource.importSettings.additionalFormatOptions.type !== 'Expression'
            ) {
                result.importSettings.additionalFormatOptions = toParameterClass(
                    resource.importSettings.additionalFormatOptions,
                    result.importSettings
                );
            } else {
                ValueAdapter.toModel(
                    result.importSettings,
                    ImportExportSettings.ADDITIONAL_FORMATOPTIONS,
                    resource.importSettings.additionalFormatOptions
                );
            }
        }
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
